export interface Component { }

export const REGISTRY = new Map<string, any>();

function getTypeFor(name: string): any {
    return REGISTRY.get(name);
}